import {API_URL, apiPost} from '../api'

interface IEditUser {
    id: string
    name?: string | null
    status?: string | null
    type?: string | null
    used_referral_code?: string
    my_referral_code?: string | null
    point_balance?: string | number | null
}

export const postEditUserReferral = async (edit_data: IEditUser) => {
    return await apiPost(API_URL, 'admin/user_edit', edit_data)
}

export const postEditUsedReferral = async (edit_data: IEditUser) => {
    return await apiPost(API_URL, 'admin/user_edit', edit_data)
}
